import { PdfViewerComponent } from '@syncfusion/ej2-react-pdfviewer';

export type PdfSyncPhase = 'idle' | 'loading-document' | 'syncing-page' | 'ready';

const PDF_VIEWER_CONTAINER_ID = 'formViewerPDF';
const MAX_GO_TO_PAGE_ATTEMPTS = 20;
const GO_TO_PAGE_RETRY_MS = 50;

export const attemptPdfGoToPage = (
    pdfViewer: PdfViewerComponent | null | undefined,
    pageIndex: number,
    onComplete?: () => void
): (() => void) => {
    if (!pdfViewer) {
        return () => {};
    }

    const targetPageNumber = pageIndex + 1;
    let attemptCount = 0;
    let timeoutId: number | null = null;

    const attemptNavigation = (): void => {
        if (!pdfViewer) {
            return;
        }

        const pdfViewerContainer = document.getElementById(PDF_VIEWER_CONTAINER_ID);
        const scrollContainer =
            pdfViewerContainer?.querySelector('.e-pv-viewer-container') ?? pdfViewerContainer?.querySelector('.e-pv-main-container');

        if (!scrollContainer) {
            attemptCount += 1;
            if (attemptCount < MAX_GO_TO_PAGE_ATTEMPTS) {
                timeoutId = window.setTimeout(attemptNavigation, GO_TO_PAGE_RETRY_MS);
            }
            return;
        }

        if (pdfViewer.currentPageNumber !== targetPageNumber) {
            pdfViewer.navigation.goToPage(targetPageNumber);
        }

        onComplete?.();
    };

    attemptNavigation();

    return () => {
        if (timeoutId !== null) {
            window.clearTimeout(timeoutId);
        }
    };
};

export const shouldAcceptPdfPageChange = (phase: PdfSyncPhase, isInitialSync: boolean): boolean => {
    if (isInitialSync) {
        return true;
    }

    return phase === 'ready' || phase === 'syncing-page';
};
